import { render, staticRenderFns } from "./PastMedicalHistory.vue?vue&type=template&id=30b47049&scoped=true&"
import script from "./PastMedicalHistory.vue?vue&type=script&lang=js&"
export * from "./PastMedicalHistory.vue?vue&type=script&lang=js&"
import style0 from "./PastMedicalHistory.vue?vue&type=style&index=0&id=30b47049&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b47049",
  null
  
)

export default component.exports